export const comics = [
  {
    id: 'dongdong-zahuopu',
    slug: 'dongdong-zahuopu',
    title: '洞洞杂货铺',
    author: '墨飞',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20cover%20illustration%20of%20a%20cozy%20grocery%20store%20shop%20with%20warm%20lighting%2C%20vintage%20wooden%20shelves%20filled%20with%20mysterious%20items%2C%20a%20young%20shopkeeper%20character%20in%20traditional%20Chinese%20clothing%2C%20whimsical%20and%20heartwarming%20atmosphere%2C%20soft%20watercolor%20style%2C%20clean%20composition%2C%20manga%20cover%20design&width=600&height=800&seq=comic-cover-01&orientation=portrait',
    status: '连载中',
    description: '在一座古老的小镇上，有一家名为"洞洞"的杂货铺。这家看似普通的杂货铺，却隐藏着不为人知的秘密——每一件商品都承载着一段独特的故事。店主阿洞是一个神秘的年轻人，他不仅出售日常用品，更帮顾客解决生活中的各种烦恼。温暖治愈的单元剧故事，带你走进一个个平凡却动人的日常。',
    category: '治愈',
    categorySlug: 'healing',
    updateTime: '2026-07-02',
    views: 1285000,
    rating: 9.6,
    tags: ['治愈', '日常', '奇幻', '单元剧'],
    chapters: [
      { num: 1, title: '第一话：奇怪的店铺', updateTime: '2026-06-01' },
      { num: 2, title: '第二话：会说话的雨伞', updateTime: '2026-06-05' },
      { num: 3, title: '第三话：记忆中的糖果', updateTime: '2026-06-10' },
      { num: 4, title: '第四话：月光下的琴声', updateTime: '2026-06-15' },
      { num: 5, title: '第五话：迷路的猫咪', updateTime: '2026-06-20' },
      { num: 6, title: '第六话：旧照片的秘密', updateTime: '2026-06-25' },
      { num: 7, title: '第七话：夏日烟火', updateTime: '2026-06-30' },
      { num: 8, title: '第八话：新来的客人', updateTime: '2026-07-02' },
    ],
  },
  {
    id: 'xinghe-zhi-lv',
    slug: 'xinghe-zhi-lv',
    title: '星河之旅',
    author: '林夏',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20cover%20illustration%20of%20a%20sci-fi%20adventure%20in%20space%2C%20a%20young%20astronaut%20floating%20among%20colorful%20nebula%20clouds%2C%20stars%20and%20galaxies%20in%20background%2C%20dreamy%20and%20poetic%20atmosphere%2C%20soft%20watercolor%20and%20ink%20wash%20style%2C%20clean%20composition&width=600&height=800&seq=comic-cover-02&orientation=portrait',
    status: '连载中',
    description: '公元2150年，人类已经掌握了星际航行的技术。少女星禾踏上了寻找失踪父亲的旅程，在一艘老旧的宇宙飞船"曙光号"上，她遇见了形形色色的旅伴，展开了一段跨越银河的奇妙冒险。',
    category: '科幻',
    categorySlug: 'sci-fi',
    updateTime: '2026-07-01',
    views: 896000,
    rating: 9.3,
    tags: ['科幻', '冒险', '亲情', '宇宙'],
    chapters: [
      { num: 1, title: '第一章：启程', updateTime: '2026-05-10' },
      { num: 2, title: '第二章：曙光号', updateTime: '2026-05-18' },
      { num: 3, title: '第三章：星际风暴', updateTime: '2026-05-26' },
      { num: 4, title: '第四章：神秘信号', updateTime: '2026-06-03' },
      { num: 5, title: '第五章：废弃空间站', updateTime: '2026-06-12' },
      { num: 6, title: '第六章：同伴', updateTime: '2026-06-21' },
      { num: 7, title: '第七章：黑洞边缘', updateTime: '2026-07-01' },
    ],
  },
  {
    id: 'jian-xian-zhuan',
    slug: 'jian-xian-zhuan',
    title: '剑仙传',
    author: '云中子',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20cover%20illustration%20of%20a%20sword%20immortal%20in%20traditional%20hanfu%20robes%20standing%20on%20a%20mountain%20peak%2C%20flowing%20long%20hair%20in%20wind%2C%20ancient%20Chinese%20landscape%20with%20misty%20mountains%20and%20pine%20trees%2C%20elegant%20ink%20painting%20style%2C%20dramatic%20composition&width=600&height=800&seq=comic-cover-03&orientation=portrait',
    status: '已完结',
    description: '凡人少年林凡，机缘巧合下获得上古剑仙传承，从此踏上修仙之路。在弱肉强食的修真世界，他以一柄凡铁剑，斩妖除魔，一步步走向剑道巅峰。一部热血与柔情并存的仙侠史诗。',
    category: '仙侠',
    categorySlug: 'xianxia',
    updateTime: '2026-06-15',
    views: 2150000,
    rating: 9.8,
    tags: ['仙侠', '热血', '修炼', '战斗'],
    chapters: [
      { num: 1, title: '第一章：凡人之躯', updateTime: '2025-08-01' },
      { num: 2, title: '第二章：剑意初现', updateTime: '2025-08-08' },
      { num: 3, title: '第三章：入门试炼', updateTime: '2025-08-16' },
      { num: 4, title: '第四章：宗门大比', updateTime: '2025-08-24' },
      { num: 5, title: '第五章：秘境探险', updateTime: '2025-09-01' },
    ],
  },
  {
    id: 'mofa-shaonv-xiaomei',
    slug: 'mofa-shaonv-xiaomei',
    title: '魔法少女小莓',
    author: '糖心',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20cover%20illustration%20of%20a%20cute%20magical%20girl%20in%20pink%20frilly%20dress%2C%20holding%20a%20sparkling%20wand%2C%20colorful%20magical%20sparks%20surrounding%20her%2C%20cherry%20blossom%20petals%20floating%2C%20kawaii%20and%20dreamy%20atmosphere%2C%20soft%20pastel%20colors%2C%20anime%20style&width=600&height=800&seq=comic-cover-04&orientation=portrait',
    status: '连载中',
    description: '普通初中生小莓在某天放学路上，遇到了一只会说话的神奇生物。从此她变身成为魔法少女，在守护城市和平的同时，也要面对青春期的种种烦恼。友情、勇气与成长的故事就此展开。',
    category: '少女',
    categorySlug: 'shojo',
    updateTime: '2026-07-03',
    views: 675000,
    rating: 9.1,
    tags: ['少女', '魔法', '校园', '友情'],
    chapters: [
      { num: 1, title: '第一话：不可思议的相遇', updateTime: '2026-05-20' },
      { num: 2, title: '第二话：变身！魔法少女', updateTime: '2026-05-28' },
      { num: 3, title: '第三话：第一个敌人', updateTime: '2026-06-05' },
      { num: 4, title: '第四话：伙伴的力量', updateTime: '2026-06-13' },
      { num: 5, title: '第五话：学园祭大作战', updateTime: '2026-06-22' },
      { num: 6, title: '第六话：新的魔法少女', updateTime: '2026-07-03' },
    ],
  },
  {
    id: 'yijie-zhentan-she',
    slug: 'yijie-zhentan-she',
    title: '异界侦探社',
    author: '黑夜',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20cover%20illustration%20of%20a%20mystery%20detective%20in%20a%20noir%20urban%20fantasy%20setting%2C%20a%20detective%20in%20trench%20coat%20standing%20in%20a%20dimly%20lit%20alley%2C%20supernatural%20elements%20subtle%20in%20background%2C%20mysterious%20and%20atmospheric%2C%20ink%20wash%20painting%20style%20with%20dramatic%20lighting&width=600&height=800&seq=comic-cover-05&orientation=portrait',
    status: '连载中',
    description: '在一座人与妖怪共存的城市里，有一家专门处理超自然案件的侦探社。社长白夜是一名半妖，他与搭档们一起破解各种离奇案件，揭开隐藏在都市阴影下的秘密。悬疑与奇幻交织的都市传说。',
    category: '悬疑',
    categorySlug: 'suspense',
    updateTime: '2026-06-28',
    views: 542000,
    rating: 9.4,
    tags: ['悬疑', '奇幻', '都市', '推理'],
    chapters: [
      { num: 1, title: '案件一：消失的钟声', updateTime: '2026-04-10' },
      { num: 2, title: '案件二：午夜画廊', updateTime: '2026-04-20' },
      { num: 3, title: '案件三：河神的委托', updateTime: '2026-05-01' },
      { num: 4, title: '案件四：镜中世界', updateTime: '2026-05-15' },
      { num: 5, title: '案件五：血色满月', updateTime: '2026-06-01' },
      { num: 6, title: '案件六：最后的证人', updateTime: '2026-06-18' },
      { num: 7, title: '案件七：真相之门', updateTime: '2026-06-28' },
    ],
  },
  {
    id: 'shikong-lvxingzhe',
    slug: 'shikong-lvxingzhe',
    title: '时空旅行者',
    author: '星尘',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20cover%20illustration%20of%20a%20time%20traveler%20standing%20at%20the%20intersection%20of%20different%20historical%20eras%2C%20ancient%20and%20modern%20elements%20collage%2C%20clock%20gears%20and%20hourglass%20motifs%2C%20mysterious%20and%20philosophical%20atmosphere%2C%20poetic%20ink%20and%20watercolor%20style&width=600&height=800&seq=comic-cover-06&orientation=portrait',
    status: '已完结',
    description: '大学生陈默意外获得了一枚能穿越时空的古董怀表，他可以在不同的历史时代间穿梭。在旅途中，他见证了历史的关键时刻，也遇见了命中注定的那个人。然而每一次穿越都在改变着未来...',
    category: '奇幻',
    categorySlug: 'fantasy',
    updateTime: '2026-05-20',
    views: 1780000,
    rating: 9.7,
    tags: ['奇幻', '穿越', '历史', '爱情'],
    chapters: [
      { num: 1, title: '序章：古董店的怀表', updateTime: '2025-11-01' },
      { num: 2, title: '第一章：盛唐长安', updateTime: '2025-11-10' },
      { num: 3, title: '第二章：大宋风华', updateTime: '2025-11-20' },
      { num: 4, title: '第三章：民国的雨', updateTime: '2025-12-01' },
      { num: 5, title: '第四章：蝴蝶效应', updateTime: '2025-12-15' },
      { num: 6, title: '终章：时间的答案', updateTime: '2026-01-05' },
    ],
  },
  {
    id: 'mengjing-shitang',
    slug: 'mengjing-shitang',
    title: '梦境食堂',
    author: '糖葫芦',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20cover%20illustration%20of%20a%20cozy%20dreamlike%20restaurant%20floating%20in%20clouds%2C%20warm%20golden%20lighting%2C%20delicious%20Chinese%20food%20dishes%20on%20wooden%20table%2C%20a%20gentle%20chef%20character%2C%20whimsical%20and%20comforting%20atmosphere%2C%20soft%20watercolor%20style&width=600&height=800&seq=comic-cover-07&orientation=portrait',
    status: '连载中',
    description: '失眠的女孩小眠，每晚都会进入同一个梦境——一家飘浮在云端的食堂。食堂的老板能做出任何你想象得到的美味，而每一位食客都有着不为人知的故事。一道菜，一个故事，一段人生。',
    category: '治愈',
    categorySlug: 'healing',
    updateTime: '2026-07-03',
    views: 456000,
    rating: 9.5,
    tags: ['治愈', '美食', '奇幻', '单元剧'],
    chapters: [
      { num: 1, title: '第一章：不眠之夜', updateTime: '2026-06-01' },
      { num: 2, title: '第二章：记忆中的红烧肉', updateTime: '2026-06-08' },
      { num: 3, title: '第三章：过期蛋糕的心愿', updateTime: '2026-06-16' },
      { num: 4, title: '第四章：异乡的一碗面', updateTime: '2026-06-24' },
      { num: 5, title: '第五章：深夜来访的女孩', updateTime: '2026-07-03' },
    ],
  },
  {
    id: 'jixie-shi',
    slug: 'jixie-shi',
    title: '机械师',
    author: '铁匠',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20cover%20illustration%20of%20a%20steampunk%20mechanic%20in%20goggles%20working%20on%20a%20giant%20robot%2C%20gears%20and%20steam%20in%20background%2C%20industrial%20revolution%20era%20Chinese%20setting%2C%20brass%20and%20copper%20tones%2C%20detailed%20mechanical%20design%2C%20ink%20and%20watercolor%20style&width=600&height=800&seq=comic-cover-08&orientation=portrait',
    status: '连载中',
    description: '在蒸汽与齿轮的时代，天才机械师铁心凭借一双巧手，修复着各种各样的机械造物。但他最大的梦想，是打造一台能飞的机器。在追梦的路上，他遇见了志同道合的伙伴，也卷入了帝国与反抗军之间的纷争。',
    category: '科幻',
    categorySlug: 'sci-fi',
    updateTime: '2026-06-29',
    views: 723000,
    rating: 9.2,
    tags: ['科幻', '蒸汽朋克', '冒险', '机械'],
    chapters: [
      { num: 1, title: '第一章：废铁堆里的天才', updateTime: '2026-04-15' },
      { num: 2, title: '第二章：蒸汽城', updateTime: '2026-04-25' },
      { num: 3, title: '第三章：飞行器蓝图', updateTime: '2026-05-05' },
      { num: 4, title: '第四章：地下竞技场', updateTime: '2026-05-18' },
      { num: 5, title: '第五章：帝国的密令', updateTime: '2026-06-01' },
      { num: 6, title: '第六章：飞向天空', updateTime: '2026-06-18' },
      { num: 7, title: '第七章：云端之上', updateTime: '2026-06-29' },
    ],
  },
  {
    id: 'huayuan-li-de-mimi',
    slug: 'huayuan-li-de-mimi',
    title: '花园里的秘密',
    author: '沐风',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20cover%20illustration%20of%20a%20beautiful%20secret%20garden%20with%20colorful%20flowers%2C%20a%20young%20girl%20discovering%20a%20hidden%20door%20among%20vines%2C%20sunlight%20filtering%20through%20leaves%2C%20magical%20and%20enchanting%20atmosphere%2C%20soft%20watercolor%20style%2C%20cottagecore%20aesthetic&width=600&height=800&seq=comic-cover-09&orientation=portrait',
    status: '已完结',
    description: '搬进祖母老房子的花音，在后院发现了一座荒废的花园。每当她照料一朵花，与花相关的回忆便会浮现。通过这座神奇的花园，花音逐渐解开了祖母年轻时的故事，也找到了自己人生的方向。',
    category: '治愈',
    categorySlug: 'healing',
    updateTime: '2026-04-10',
    views: 1100000,
    rating: 9.6,
    tags: ['治愈', '日常', '亲情', '园艺'],
    chapters: [
      { num: 1, title: '第一章：祖母的房子', updateTime: '2025-09-01' },
      { num: 2, title: '第二章：被遗忘的花园', updateTime: '2025-09-15' },
      { num: 3, title: '第三章：第一朵玫瑰', updateTime: '2025-10-01' },
      { num: 4, title: '第四章：勿忘我', updateTime: '2025-10-20' },
      { num: 5, title: '第五章：祖母的日记', updateTime: '2025-11-10' },
      { num: 6, title: '终章：花开的季节', updateTime: '2025-12-05' },
    ],
  },
  {
    id: 'qishi-yu-elon',
    slug: 'qishi-yu-elon',
    title: '骑士与恶龙',
    author: '狂风',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20cover%20illustration%20of%20a%20knight%20in%20shining%20armor%20facing%20a%20majestic%20dragon%2C%20medieval%20fantasy%20setting%20with%20castle%20in%20background%2C%20dramatic%20sunset%20sky%2C%20epic%20adventure%20atmosphere%2C%20detailed%20ink%20and%20watercolor%20style%2C%20heroic%20composition&width=600&height=800&seq=comic-cover-10&orientation=portrait',
    status: '连载中',
    description: '被王国放逐的骑士艾德，在荒野中遇到了一条受伤的幼龙。一人一龙结下了奇妙的羁绊，踏上了寻找传说中龙之谷的旅程。然而王国的追兵和暗黑势力正在逼近，一场史诗般的冒险即将展开。',
    category: '冒险',
    categorySlug: 'adventure',
    updateTime: '2026-07-01',
    views: 890000,
    rating: 9.4,
    tags: ['冒险', '奇幻', '友情', '西方'],
    chapters: [
      { num: 1, title: '第一章：放逐', updateTime: '2026-03-10' },
      { num: 2, title: '第二章：悬崖边的相遇', updateTime: '2026-03-22' },
      { num: 3, title: '第三章：月下的誓约', updateTime: '2026-04-05' },
      { num: 4, title: '第四章：黑森林', updateTime: '2026-04-20' },
      { num: 5, title: '第五章：精灵之都', updateTime: '2026-05-08' },
      { num: 6, title: '第六章：追兵', updateTime: '2026-05-25' },
      { num: 7, title: '第七章：龙之谷的传说', updateTime: '2026-06-12' },
      { num: 8, title: '第八章：试炼之门', updateTime: '2026-07-01' },
    ],
  },
  {
    id: 'xuexiao-guaitan',
    slug: 'xuexiao-guaitan',
    title: '学校怪谈',
    author: '夜影',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20cover%20illustration%20of%20a%20haunted%20school%20corridor%20at%20night%2C%20flickering%20lights%2C%20shadowy%20figure%20in%20distance%2C%20eerie%20and%20mysterious%20atmosphere%2C%20Japanese%20horror%20manga%20style%2C%20dark%20ink%20wash%20with%20minimal%20color%2C%20creepy%20yet%20beautiful&width=600&height=800&seq=comic-cover-11&orientation=portrait',
    status: '连载中',
    description: '转学生小夜来到了一所传闻中闹鬼的学校。每晚午夜，学校里总会出现各种不可思议的现象。小夜和几个同样对灵异事件感兴趣的同学组成了"怪谈研究社"，开始调查学校背后的真相。',
    category: '悬疑',
    categorySlug: 'suspense',
    updateTime: '2026-06-30',
    views: 960000,
    rating: 9.5,
    tags: ['悬疑', '恐怖', '校园', '灵异'],
    chapters: [
      { num: 1, title: '第一卷：音乐教室的钢琴声', updateTime: '2026-04-01' },
      { num: 2, title: '第二卷：三楼的女厕所', updateTime: '2026-04-15' },
      { num: 3, title: '第三卷：生物室的人体模型', updateTime: '2026-05-01' },
      { num: 4, title: '第四卷：天台上的影子', updateTime: '2026-05-18' },
      { num: 5, title: '第五卷：旧校舍', updateTime: '2026-06-05' },
      { num: 6, title: '第六卷：真相', updateTime: '2026-06-22' },
      { num: 7, title: '第七卷：新的开始', updateTime: '2026-06-30' },
    ],
  },
  {
    id: 'tiankong-cheng',
    slug: 'tiankong-cheng',
    title: '天空城',
    author: '云翼',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20cover%20illustration%20of%20a%20floating%20city%20in%20the%20sky%20among%20clouds%2C%20airships%20and%20winged%20people%2C%20fantasy%20steampunk%20setting%2C%20golden%20sunset%20lighting%2C%20grand%20and%20breathtaking%20scale%2C%20detailed%20watercolor%20and%20ink%20style%2C%20epic%20fantasy%20composition&width=600&height=800&seq=comic-cover-12&orientation=portrait',
    status: '连载中',
    description: '在云端之上，有一座人类与翼人共同生活的天空城。少女云雀是一名见习信使，每天驾驶着小型飞空艇穿梭于各个浮岛之间。某天，她收到了一封来自地面的信——这封信将颠覆整个天空城的秩序。',
    category: '奇幻',
    categorySlug: 'fantasy',
    updateTime: '2026-06-27',
    views: 634000,
    rating: 9.3,
    tags: ['奇幻', '冒险', '飞行', '架空世界'],
    chapters: [
      { num: 1, title: '第一章：云上的信使', updateTime: '2026-04-20' },
      { num: 2, title: '第二章：来自地面的信', updateTime: '2026-05-02' },
      { num: 3, title: '第三章：禁区的秘密', updateTime: '2026-05-16' },
      { num: 4, title: '第四章：风暴之眼', updateTime: '2026-06-01' },
      { num: 5, title: '第五章：坠落', updateTime: '2026-06-15' },
      { num: 6, title: '第六章：地面世界', updateTime: '2026-06-27' },
    ],
  },
];

export const categories = [
  { name: '治愈', slug: 'healing', icon: 'ri-heart-pulse-line', count: 156 },
  { name: '科幻', slug: 'sci-fi', icon: 'ri-rocket-line', count: 89 },
  { name: '仙侠', slug: 'xianxia', icon: 'ri-sword-line', count: 234 },
  { name: '少女', slug: 'shojo', icon: 'ri-star-line', count: 178 },
  { name: '悬疑', slug: 'suspense', icon: 'ri-search-eye-line', count: 112 },
  { name: '奇幻', slug: 'fantasy', icon: 'ri-magic-line', count: 145 },
  { name: '冒险', slug: 'adventure', icon: 'ri-compass-3-line', count: 167 },
  { name: '日常', slug: 'slice-of-life', icon: 'ri-sun-line', count: 98 },
  { name: '热血', slug: 'action', icon: 'ri-fire-line', count: 203 },
  { name: '搞笑', slug: 'comedy', icon: 'ri-emotion-laugh-line', count: 121 },
];

export const banners = [
  {
    id: 1,
    comicSlug: 'dongdong-zahuopu',
    title: '洞洞杂货铺',
    subtitle: '温暖治愈的单元剧故事',
    description: '每一件商品都承载着一段独特的故事，走进洞洞杂货铺，发现平凡中的不凡。',
    image: 'https://readdy.ai/api/search-image?query=Warm%20and%20cozy%20Chinese%20grocery%20store%20interior%20with%20vintage%20wooden%20shelves%20filled%20with%20various%20items%2C%20soft%20golden%20afternoon%20light%20streaming%20through%20window%2C%20a%20young%20shopkeeper%20in%20traditional%20clothing%2C%20whimsical%20and%20heartwarming%20atmosphere%2C%20watercolor%20illustration%20style%2C%20warm%20amber%20and%20cream%20tones%2C%20rich%20detailed%20composition%20with%20depth&width=1600&height=700&seq=banner-01&orientation=landscape',
    badge: '本周热门',
  },
  {
    id: 2,
    comicSlug: 'jian-xian-zhuan',
    title: '剑仙传',
    subtitle: '热血修仙史诗巨作',
    description: '凡人少年持剑问天，斩妖除魔登临剑道巅峰。',
    image: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20xianxia%20landscape%20of%20a%20swordsman%20standing%20on%20misty%20mountain%20peak%20at%20sunrise%2C%20flowing%20robes%20in%20wind%2C%20ancient%20pine%20trees%2C%20dramatic%20clouds%2C%20golden%20light%2C%20traditional%20ink%20painting%20style%20blended%20with%20modern%20illustration%2C%20heroic%20and%20breathtaking&width=1600&height=700&seq=banner-02&orientation=landscape',
    badge: '经典必读',
  },
  {
    id: 3,
    comicSlug: 'shikong-lvxingzhe',
    title: '时空旅行者',
    subtitle: '穿越时空的浪漫之旅',
    description: '一枚古董怀表，跨越千年的爱恋与冒险。',
    image: 'https://readdy.ai/api/search-image?query=Dreamy%20time%20travel%20concept%20with%20floating%20clock%20gears%20and%20hourglass%2C%20different%20historical%20eras%20collage%20from%20ancient%20China%20to%20modern%20city%2C%20soft%20watercolor%20and%20ink%20wash%20style%2C%20mysterious%20and%20romantic%20atmosphere%2C%20warm%20golden%20and%20sepia%20tones&width=1600&height=700&seq=banner-03&orientation=landscape',
    badge: '好评如潮',
  },
];

export const reviews = [
  {
    id: 1,
    name: '小明爱吃糖',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20avatar%20of%20a%20young%20boy%20with%20warm%20smile%2C%20simple%20clean%20background%2C%20soft%20colors%2C%20chibi%20style&width=80&height=80&seq=avatar-01&orientation=squarish',
    rating: 5,
    content: '洞洞杂货铺真的太好看了！每个故事都让人心里暖暖的，画风也很舒服。强烈推荐给喜欢治愈系的朋友们！',
    date: '2026-07-01',
  },
  {
    id: 2,
    name: '漫画狂热者',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20avatar%20of%20a%20girl%20with%20glasses%20and%20ponytail%2C%20enthusiastic%20expression%2C%20simple%20clean%20background%2C%20chibi%20style&width=80&height=80&seq=avatar-02&orientation=squarish',
    rating: 5,
    content: '073漫画网是我用过最流畅的漫画阅读平台，下拉式阅读体验真的太棒了，加载速度也很快。推荐给身边所有朋友了！',
    date: '2026-06-28',
  },
  {
    id: 3,
    name: '夜空守望者',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20avatar%20of%20a%20cool%20looking%20teenager%20with%20headphones%2C%20calm%20expression%2C%20simple%20clean%20background%2C%20chibi%20style&width=80&height=80&seq=avatar-03&orientation=squarish',
    rating: 5,
    content: '剑仙传的剧情感太强了，一口气追完了所有章节。网站的更新也很及时，每次出新章节都能第一时间看到。',
    date: '2026-06-25',
  },
  {
    id: 4,
    name: '午后红茶',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20avatar%20of%20a%20gentle%20girl%20with%20long%20hair%2C%20peaceful%20smile%2C%20simple%20clean%20background%2C%20chibi%20style&width=80&height=80&seq=avatar-04&orientation=squarish',
    rating: 4,
    content: '梦境食堂的画风太美了，每一话的食物画得让人流口水。073的阅读体验也没得说，下拉就能看，太方便了。',
    date: '2026-06-20',
  },
  {
    id: 5,
    name: '疾风少年',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20avatar%20of%20a%20energetic%20boy%20with%20spiky%20hair%2C%20bright%20smile%2C%20simple%20clean%20background%2C%20chibi%20style&width=80&height=80&seq=avatar-05&orientation=squarish',
    rating: 5,
    content: '时空旅行者完结了！虽然有点舍不得，但结局真的很圆满。073漫画网的收藏功能也很好用，追漫不用愁。',
    date: '2026-06-18',
  },
  {
    id: 6,
    name: '墨香读者',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20avatar%20of%20a%20scholarly%20looking%20person%20with%20round%20glasses%2C%20gentle%20smile%2C%20simple%20clean%20background%2C%20chibi%20style&width=80&height=80&seq=avatar-06&orientation=squarish',
    rating: 5,
    content: '作为一个看了十多年漫画的老读者，073漫画网的品质真的让我惊喜。分类清晰、更新快、阅读体验好，五星好评！',
    date: '2026-06-15',
  },
];